import { compose } from "recompose";
import { graphql } from "react-apollo";

const EnhanceFooter = ({ UserQuery }) =>
  compose(
    graphql(UserQuery, {
      name: "me",
    })
  );

export default EnhanceFooter;
